// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"66":"f01014d6","235":"b11eeb3b","979":"f6784a50"}[chunkId] + ".js";
};